import { Injectable } from '@angular/core';
import { en_GB, fr_FR, es_ES, nl_NL, pt_PT } from 'ng-zorro-antd/i18n';

@Injectable()
export class LocaleService {
  private currentLocale: string;

  constructor() {
    this.currentLocale = localStorage.getItem('locale') || 'en-US';
  }

  getLocale(): string {
    return this.currentLocale;
  }

  setLocale(locale: string): void {
    this.currentLocale = locale;
    localStorage.setItem('locale', locale);
    window.location.reload();
  }

  getNzLocale(): any {
    const localeMap = {
      'en-US': en_GB,
      'en-GB': en_GB,
      'fr-FR': fr_FR,
      'es-ES': es_ES,
      'nl-NL': nl_NL,
      'pt-PT': pt_PT,
    };
    return localeMap[this.currentLocale] || en_GB;
  }
}

export function initializeLocale(localeService: LocaleService) {
  return () => {
    const locale = localeService.getLocale();
    return locale;
  };
}
